import { userObservationsApi } from './index'

export default userObservationsApi.middleware
